import { Divider, Link, type LinkProps, Stack } from '@mui/material';
import { Link as ReactRouterLink } from 'react-router-dom';

import { Text, mergeSxProps } from '@notablehealth/design-system';

import { useSidebarNavigationRouteSectionsContext } from './sidebarRoutes';
import { type RouteLink } from '../../common';
import { SideNavigationState, useSideNavigationModeContext } from '../../context';

interface SidebarNavigationLinkProps extends Pick<LinkProps, 'sx' | 'onClick'> {
  link: RouteLink;
  borderMode?: 'None' | 'LeftDivider';
}

export function SidebarNavigationLink(props: SidebarNavigationLinkProps) {
  const { link, sx, borderMode = 'LeftDivider', onClick } = props;
  const { bestMatchNavigationLink } = useSidebarNavigationRouteSectionsContext();
  const { sideNavigationState } = useSideNavigationModeContext();

  const linkIsBestRouteMatch = bestMatchNavigationLink?.to === link.to;

  return (
    <Stack direction="row" spacing={1}>
      {borderMode === 'LeftDivider' && (
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderColor: linkIsBestRouteMatch ? 'secondary.contrastText' : 'divider' }}
        />
      )}
      <Text
        variant="paragraph-medium"
        sx={{
          display: 'inline-block',
          width: '100%',
        }}
      >
        <Link
          component={ReactRouterLink}
          to={link.to}
          onClick={onClick}
          color="inherit"
          underline="none"
          tabIndex={sideNavigationState === SideNavigationState.Collapsed ? -1 : 0}
          sx={mergeSxProps(
            {
              display: 'inline-block',
              width: '100%',
              paddingX: 1.5,
              paddingY: 0.5,
            },
            sx,
            linkIsBestRouteMatch
              ? {
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    opacity: 1,
                  },
                }
              : {
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                }
          )}
        >
          {link.label}
        </Link>
      </Text>
    </Stack>
  );
}
